import { styled } from '@mui/material'
import { Link } from 'react-router-dom'

export const Root = styled('div')`
  display: block;
  height: auto;
  position: relative;
  width: 100%;
`

export const Row = styled('div')`
  display: flex;
  justify-content: ${({ align }) => {
    if (align === 'right') {
      return 'flex-end'
    }
    if (align === 'center') {
      return 'center'
    }
    return 'flex-start'
  }};
  margin: ${props => props.margin || 0};
  width: 100%;

  ${props => props.theme.breakpoints.down('sm')} {
    display: ${props => (props.align === 'center' ? 'flex' : 'block')};
  }
`

export const Brand = styled('img')`
  height: ${props => (props.size === 'small' ? '42px' : '64px')};
  margin: ${props => props.margin};
  pointer-events: none;
  user-select: none;

  ${props => props.theme.breakpoints.down('sm')} {
    height: ${props => (props.size === 'small' ? '32px' : '42px')};
  }
`

export const BrandLink = styled(Link)`
  margin: 0;
`
